/* eslint-disable react/no-array-index-key */
import React from 'react';
import { omit } from 'lodash';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import AppointmentInfo from '../../shared/AppointmentInfo';
import ShopLocation from '../../shared/ShopLocation';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import Title from './components/Title';
import Breakdown from './components/Breakdown';
import PostCtaAction from './components/PostCtaAction';
import withReceiptNotification from '../../hoc/withReceiptNotification';
import ReceiptCta from '../../shared/ReceiptCta';

/* eslint-disable react/prop-types */
const CustomerReminder = ({
  shop,
  receipt,
  address,
  transactionId,
  appLink,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} />
    <NotificationContent>
      <Title
        last4={receipt.last4}
        refunded={receipt.refunded}
      />
      <div className="u-mb-20 u-hide-on-mobile" />
      <div className="u-mb-10 u-hide-on-desktop" />
      <Breakdown
        total={receipt.total}
        date={receipt.date}
        datetime={receipt.datetime}
        subtotal={receipt.subtotal}
        tip={receipt.tip}
        taxesAndFees={receipt.taxAndFee}
        promo={receipt.promo}
        promoCode={receipt.promoCode}
        discount={receipt.discount}
        items={receipt.items}
        totalByType={receipt.totalByType}
        last4={receipt.last4}
        brand={receipt.brand}
        transactionId={transactionId}
        refunded={receipt.refunded}
        giftCardCode={receipt.giftCardCode}
      />
      {receipt.appointments.length ? (
        <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey">
          Your Appointment
        </div>
      ) : null}
      {receipt.appointments.length ? (
        <div className="u-flex u-justify-content-space-between u-flex-wrap u-mt-4">
          <AppointmentInfo appointments={receipt.appointments.map(appt => omit(appt, ['customerName']))} />
          <div className="c-appointment-info-divider u-hide-on-desktop" />
          <ShopLocation
            fixed
            shopName={shop.name}
            phone={shop.phone}
            line1={address.line1}
            line2={address.line2}
            map={shop.staticMap.url}
            directions={address.directions}
          />
        </div>
      ) : null}
      { shop.mobileAppCta && <ReceiptCta appointments={receipt.appointments} appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="receipt" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withReceiptNotification(CustomerReminder);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Receipt/index.jsx